declare global {
  interface Window {
    opera?: string
  }
}

// function isInWebView() {
//   const userAgent =
//     navigator.userAgent || navigator.vendor || window?.opera || ""

//   const isAndroidWebView =
//     /wv/.test(userAgent) || /\bVersion\/[\d.]+.*Chrome/.test(userAgent)
//   const isIOSWebView = (function () {
//     return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/.test(userAgent)
//   })()

//   return isAndroidWebView || isIOSWebView
// }

export const isInApp = () => {
  return (
    window.webkit?.messageHandlers["NDCApp.addEventToCalendar"] ||
    (window.NDCApp && typeof window.NDCApp.addEventToCalendar === "function")
  )

  // return isInWebView()

  // return (
  //   typeof Cookies.get("_if_game_auth") === "string" &&
  //   typeof Cookies.get("_ifgid") === "string" &&
  //   typeof Cookies.get("_ifgt") === "string" &&
  //   typeof Cookies.get("_iflocale") === "string" &&
  //   typeof Cookies.get("_ifplatform_selector") === "string" &&
  //   typeof Cookies.get("_ifwt") === "string" &&
  //   typeof Cookies.get("_ifwt_sso") === "string"
  // )
}
